<template>
  <v-row>
    <v-col cols="12">
      <embed
        src="https://ppic.iotech.my.id/?app=ACCOUNTING#/jobdepttemplates"
        width="100%"
        height="800"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "job-dept-template-overview",
};
</script>

<style></style>
